import { render, staticRenderFns } from "./TaskDetailSummary.vue?vue&type=template&id=d477146e"
import script from "./TaskDetailSummary.vue?vue&type=script&lang=js"
export * from "./TaskDetailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports